import useLogEvent from 'amplitude/useLogEvent'
import React from 'react'

const BraintreeBadge = () => {
  const logEvent = useLogEvent()

  return (
    <a
      href={`https://www.braintreegateway.com/merchants/${process.env.REACT_APP_BRAINTREE_MERCHANT_ID}/verified`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => logEvent('Click Braintree Badge')}
      style={{
        display: 'flex',
      }}
    >
      <img src="/badge_braintree.webp" height={39} alt="Powered by Braintree" />
    </a>
  )
}

export default BraintreeBadge
